import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactEmoji from 'react-emoji';
import axios from 'axios';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeContact, setActiveContact] = useState(null);
  const [messageInput, setMessageInput] = useState('');
  const [contacts, setContacts] = useState([]);
  const [messages, setMessages] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loginKefu, setLoginKefu] = useState('');
  const [filerList, setFilterList] = useState([]);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [init, setInit] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyMessages, setHistoryMessages] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [showCloseSessionConfirm, setShowCloseSessionConfirm] = useState(false);
  const [quickReplies, setQuickReplies] = useState([]);
  const [activeCategory, setActiveCategory] = useState('');

  // 新增备注编辑弹窗相关状态
  const [showNicknameModal, setShowNicknameModal] = useState(false);
  const [newNickname, setNewNickname] = useState('');
  const [editingContact, setEditingContact] = useState(null);
  const [isUpdatingNickname, setIsUpdatingNickname] = useState(false);

  // 新增状态：预览图片相关
  const [previewImage, setPreviewImage] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewImageFile, setPreviewImageFile] = useState(null);

  // 添加置顶联系人状态
  const [pinnedContacts, setPinnedContacts] = useState(() => {
    const saved = localStorage.getItem('pinnedContacts');
    return saved ? JSON.parse(saved) : [];
  });

  // 添加状态用于存储所有联系人的最后消息
  const [contactsLastMessages, setContactsLastMessages] = useState({});

  // ... 其他状态保持不变 ...
  const [status, setStatus] = useState('online');

  // 在状态变量中添加连续发送消息计数
  // 修改状态变量，使用对象存储每个联系人的计数
  const [continuousSendCount, setContinuousSendCount] = useState(() => {
    const saved = localStorage.getItem('continuousSendCount');
    return saved ? JSON.parse(saved) : {};
  });

  const [showSendLimitModal, setShowSendLimitModal] = useState(false);

  // 添加通用 alert 状态
  const [alertInfo, setAlertInfo] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null,
    showCancel: false,
    onCancel: null
  });

  // 显示通用 alert 的函数
  const showAlert = useCallback((title, message, onConfirm = null, showCancel = false, onCancel = null) => {
    setAlertInfo({
      show: true,
      title,
      message,
      onConfirm: onConfirm || (() => setAlertInfo(prev => ({...prev, show: false}))),
      showCancel,
      onCancel: onCancel || (() => setAlertInfo(prev => ({...prev, show: false})))
    });
  }, []);

  // 关闭 alert 的函数
  const closeAlert = useCallback(() => {
    setAlertInfo(prev => ({...prev, show: false}));
  }, []);

  // 修改 messageInput 状态为一个对象，以 external_userid 为键存储每个联系人的输入内容
  const [messageInputs, setMessageInputs] = useState({});

  // 获取当前联系人的输入内容
  const currentMessageInput = activeContact 
    ? messageInputs[activeContact.external_userid] || '' 
    : '';

  // 在状态变量中添加
  const [lastReadTimes, setLastReadTimes] = useState(() => {
    const saved = localStorage.getItem('lastReadTimes');
    return saved ? JSON.parse(saved) : {};
  });
  
  // 新增状态：记录最后获取消息的时间戳
  const [lastMessageTime, setLastMessageTime] = useState(0);
  const [lastContactTime, setLastContactTime] = useState(0);

  // 添加表情选择器状态
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const wechatEmojiMap = {
    // 经典黄脸表情系列
    '[微笑]': '🙂',
    '[笑脸]': '😀',
    '[撇嘴]': '😕',
    '[色]': '😍',
    '[发呆]': '😲',
    '[得意]': '😎',
    '[流泪]': '😭',
    '[害羞]': '😊',
    '[闭嘴]': '🤐',
    '[睡]': '😴',
    '[大哭]': '😢',
    '[尴尬]': '😅',
    '[发怒]': '😠',
    '[调皮]': '😜',
    '[呲牙]': '😁',
    '[惊讶]': '😮',
    '[难过]': '😞',
    '[酷]': '🆒',
    '[冷汗]': '😰',
    '[抓狂]': '😫',
    '[吐]': '🤮',
    '[偷笑]': '😏',
    '[愉快]': '😀',
    '[白眼]': '🙄',
    '[傲慢]': '😤',
    '[饥饿]': '🤤',
    '[困]': '😪',
    '[惊恐]': '😱',
    '[流汗]': '💦',
    '[憨笑]': '😄',
    '[悠闲]': '😌',
    '[奋斗]': '💪',
    '[咒骂]': '🤬',
    '[疑问]': '❓',
    '[嘘]': '🤫',
    '[晕]': '😵',
    '[敲打]': '👊',
    '[再见]': '👋',
    '[发抖]': '🥶',
    
    // 特殊黄脸表情
    '[坏笑]': '😏', // 添加的坏笑表情
    '[阴险]': '😈',
    '[憨笑]': '😄',
    '[可怜]': '🥺',
    '[鄙视]': '🙄',
    '[委屈]': '😔',
    '[快哭了]': '😢',
    
    // 物品/动物系列
    '[爱情]': '💑',
    '[跳跳]': '💃',
    '[炸弹]': '💣',
    '[便便]': '💩',
    '[月亮]': '🌙',
    '[太阳]': '☀️',
    '[礼物]': '🎁',
    '[拥抱]': '🤗',
    '[强]': '👍',
    '[弱]': '👎',
    '[握手]': '🤝',
    '[胜利]': '✌️',
    '[抱拳]': '🙏',
    '[勾引]': '👉',
    '[拳头]': '✊',
    '[OK]': '👌',
    '[咖啡]': '☕',
    '[饭]': '🍚',
    '[玫瑰]': '🌹',
    '[凋谢]': '🥀',
    '[爱心]': '❤️',
    '[心碎]': '💔',
    '[蛋糕]': '🎂',
    '[啤酒]': '🍺',
    '[猪头]': '🐷',
    '[凋谢]': '🥀',
    '[嘴唇]': '💋',
    '[骷髅]': '💀',
    
    // 新版表情系列 (2020+)
    '[吃瓜]': '🍉',
    '[加油]': '⛽',
    '[汗]': '😓',
    '[天啊]': '😱',
    '[Emm]': '🤔',
    '[社会社会]': '👥',
    '[旺柴]': '🐶',
    '[好的]': '👌',
    '[哇]': '😮',
    '[打脸]': '🤕',
    '[破涕为笑]': '😂',
    '[苦涩]': '😫',
    '[裂开]': '💔',
    '[让我看看]': '👀',
    '[666]': '🤘',
    '[福]': '🧧',
    '[叹气]': '😮‍💨',
    '[翻白眼]': '🙄',
    '[烟花]': '🎆',
    '[爆竹]': '🧨',
    '[红包]': '🧧',
    '[庆祝]': '🎉',
    '[合十]': '🙏',
    
    // 2023新增表情
    '[裂开]': '🤯',
    '[苦涩]': '🥴',
    '[让我看看]': '👁️',
    '[666]': '🤙',
    '[社会社会]': '💼',
    '[旺柴]': '🦊',
    '[好的]': '👌🏻',
    '[打call]': '📱',
    '[哇]': '🤩',
    '[苦涩]': '😖',
    
    // 其他补充表情
    '[嘿哈]': '🤪',
    '[捂脸]': '🤦',
    '[奸笑]': '😼',
    '[机智]': '🤓',
    '[皱眉]': '😟',
    '[耶]': '✌️',
    '[鸡]': '🐔',
    '[發]': '🀄',
    '[红包]': '🧧',
    '[福]': '🧧',
    '[裂开]': '🤯',
    
    // 手势系列
    '[拳头]': '✊',
    '[OK]': '👌',
    '[合十]': '🙏',
    '[抱拳]': '🙏',
    '[勾引]': '👆',
    '[胜利]': '✌️',
    
    // 补充遗漏的常用表情
    '[擦汗]': '😥',
    '[抠鼻]': '🤏👃',
    '[鼓掌]': '👏',
    '[糗大了]': '😳',
    '[坏笑]': '😈', // 另一种坏笑表示
    '[左哼哼]': '😤⬅️',
    '[右哼哼]': '😤➡️',
    '[哈欠]': '🥱',
    '[委屈]': '😔',
    '[快哭了]': '😭',
    '[菜刀]': '🔪',
    '[西瓜]': '🍉',
    '[篮球]': '🏀',
    '[乒乓]': '🏓',
    '[咖啡]': '☕',
    '[饭]': '🍚',
    '[猪头]': '🐷',
    '[玫瑰]': '🌹',
    '[凋谢]': '🥀',
    '[爱心]': '❤️',
    '[心碎]': '💔',
    '[蛋糕]': '🎂',
    '[闪电]': '⚡',
    '[炸弹]': '💣',
    '[刀]': '🔪',
    '[足球]': '⚽',
    '[虫]': '🐛',
    '[便便]': '💩',
    '[月亮]': '🌙',
    '[太阳]': '☀️',
    '[礼物]': '🎁',
    '[拥抱]': '🤗',
    '[强]': '💪',
    '[弱]': '😣',
    '[握手]': '🤝',
  };

  const chatWindowRef = useRef(null);
  const isScrolledToBottomRef = useRef(true);

  const activeContactRef = useRef(activeContact);
  useEffect(() => {
    activeContactRef.current = activeContact;
  }, [activeContact]);

  // 滚动到底部
  const scrollToBottom = useCallback(() => {
    if (chatWindowRef.current) {
      const element = chatWindowRef.current;
      element.scrollTop = element.scrollHeight;
    }
  }, []);

  // 新增状态：存储每个联系人的输入框高度
  const [inputHeights, setInputHeights] = useState({});
  
  // 当前输入框高度
  const currentInputHeight = activeContact 
    ? inputHeights[activeContact.external_userid] || 60 
    : 60;

  // 拖动手柄引用
  const resizeHandleRef = useRef(null);
  const topResizeHandleRef = useRef(null); // 新增顶部拖动手柄引用

  // 添加表情选择器引用
  const emojiPickerRef = useRef(null);

  // 处理拖动手柄的鼠标按下事件
  const handleResizeMouseDown = useCallback((e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = currentInputHeight;
    
    const handleMouseMove = (moveEvent) => {
      const deltaY = moveEvent.clientY - startY;
      let newHeight = startHeight - deltaY;
      
      // 限制最小和最大高度
      if (newHeight < 60) newHeight = 60;
      if (newHeight > 200) newHeight = 200;
      
      if (activeContact) {
        setInputHeights(prev => ({
          ...prev,
          [activeContact.external_userid]: newHeight
        }));
      }
    };
    
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [activeContact, currentInputHeight]);

  // 获取当前联系人的计数
  const getCurrentContactCount = useCallback(() => {
    if (!activeContact) return 0;
    const contactId = activeContact.external_userid;
    
    // 检查计数器是否存在且是否过期（超过1小时）
    const counter = continuousSendCount[contactId];
    if (counter && Date.now() - counter.lastUpdate > 3600000) {
      // 计数器过期，重置为0
      return 0;
    }
    
    return counter?.count || 0;
  }, [activeContact, continuousSendCount]);

  // 更新当前联系人的计数
  const updateCurrentContactCount = useCallback((newCount) => {
    if (!activeContact) return;
    
    const contactId = activeContact.external_userid;
    
    setContinuousSendCount(prev => ({
      ...prev,
      [contactId]: {
        count: newCount,
        lastUpdate: Date.now()
      }
    }));
  }, [activeContact]);

  // 重置当前联系人的计数
  const resetCurrentContactCount = useCallback(() => {
    if (!activeContact) return;
    
    const contactId = activeContact.external_userid;

    // 计算当前联系人的连续发送条数
    let continuousCount = 0;
    
    // 从后往前遍历消息，计算连续发送的客服消息数量
    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i];
      
      // 只统计当前联系人的消息
      if (msg.external_userid !== contactId) continue;
      
      // 如果遇到用户消息，停止计数
      if (msg.from === 'user') break;
      
      // 统计客服发送的消息（包括文字、图片、视频、音频）
      continuousCount++;
    }
    
    setContinuousSendCount(prev => ({
      ...prev,
      [contactId]: {
        count: continuousCount,
        lastUpdate: Date.now()
      }
    }));
  }, [activeContact]);

  // 保存计数到本地存储
  useEffect(() => {
    localStorage.setItem('continuousSendCount', JSON.stringify(continuousSendCount));
  }, [continuousSendCount]);

  // 新增：处理顶部拖动手柄的鼠标按下事件
  const handleTopResizeMouseDown = useCallback((e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = currentInputHeight;
    
    const handleMouseMove = (moveEvent) => {
      const deltaY = moveEvent.clientY - startY;
      let newHeight = startHeight - deltaY; // 向上拖动增加高度，向下拖动减小高度
      
      // 限制最小和最大高度
      if (newHeight < 60) newHeight = 60;
      if (newHeight > 200) newHeight = 200;
      
      if (activeContact) {
        setInputHeights(prev => ({
          ...prev,
          [activeContact.external_userid]: newHeight
        }));
      }
    };
    
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [activeContact, currentInputHeight]);

  // 使用映射表将中文描述转换为Unicode编码
  const convertChineseToUnicode = (chineseText) => {
    // 创建别名映射
    const aliasMap = {
      '[笑哭]': '[破涕为笑]',
      '[恐惧]': '[惊恐]',
      '[爱心]': '[爱情]',
      '[点赞]': '[强]',
      '[弱]': '[弱]',
      '[鼓掌]': '👏',
      '[饭]': '🍚',
      '[奸笑]': '[坏笑]',
      '[阴险笑]': '[坏笑]',
    };
    
    return chineseText.replace(/\[[^\]]+\]/g, (match) => {
      // 处理别名
      const aliased = aliasMap[match] || match;
      
      // 返回匹配的emoji或原文本
      return wechatEmojiMap[aliased] || 
             wechatEmojiMap[aliased.toLowerCase()] || 
             match;
    });
  };

  // 监听滚动位置
  useEffect(() => {
    const handleScroll = () => {
      if (chatWindowRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = chatWindowRef.current;
        const isAtBottom = scrollHeight - scrollTop <= clientHeight + 10;
        isScrolledToBottomRef.current = isAtBottom;
      }
    };

    const element = chatWindowRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
      return () => element.removeEventListener('scroll', handleScroll);
    }
  }, []);

  // 监听点击外部关闭表情选择器
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 插入表情到输入框
  const insertEmoji = (emojiKey) => {
    if (!activeContact) return;
    
    const contactId = activeContact.external_userid;
    const currentInput = messageInputs[contactId] || '';
    
    setMessageInputs(prev => ({
      ...prev,
      [contactId]: currentInput + emojiKey
    }));
    
    // 关闭表情选择器
    setShowEmojiPicker(false);
  };

  // 保存置顶联系人到本地存储
  useEffect(() => {
    localStorage.setItem('pinnedContacts', JSON.stringify(pinnedContacts));
  }, [pinnedContacts]);

  // ... 其他状态保持不变 ...

  // 置顶联系人
  const pinContact = (contactId) => {
    if (!pinnedContacts.includes(contactId)) {
      setPinnedContacts([contactId, ...pinnedContacts]);
    }
  };

  // 取消置顶
  const unpinContact = (contactId) => {
    setPinnedContacts(pinnedContacts.filter(id => id !== contactId));
  };

  // 组织联系人数据（置顶 + 普通）
  const organizeContacts = (contacts) => {
    const pinned = contacts.filter(contact => 
      pinnedContacts.includes(contact.external_userid)
    );
    
    const unpinned = contacts.filter(contact => 
      !pinnedContacts.includes(contact.external_userid)
    );
    
    return { pinned, unpinned };
  };

  // 获取组织后的联系人
  const { pinned, unpinned } = organizeContacts(contacts);

  // 当有新消息或切换联系人时滚动到底部
  useEffect(() => {
    if (isScrolledToBottomRef.current) {
      scrollToBottom();
    }
  }, [messages, activeContact, scrollToBottom]);
  
  const contactsIntervalRef = useRef(null);
  const messagesIntervalRef = useRef(null);

  // 打开备注编辑弹窗
  const openNicknameModal = (contact) => {
    setEditingContact(contact);
    setNewNickname(contact.nickname);
    setShowNicknameModal(true);
  };

  // 确认修改备注
  const handleConfirmNickname = async () => {
    if (!editingContact || !newNickname.trim()) return;
    
    setIsUpdatingNickname(true);
    try {
      // 发送备注修改请求
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/update-remark', {
        username: localStorage.getItem('username'),
        external_userid: editingContact.external_userid,
        remark: newNickname.trim()
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      if (response.data.code === 1) {
        // 更新本地联系人列表
        setContacts(prevContacts => prevContacts.map(contact => 
          contact.external_userid === editingContact.external_userid 
            ? { ...contact, nickname: newNickname.trim() } 
            : contact
        ));
        
        // 如果当前活跃联系人是被修改的联系人，更新其显示
        if (activeContact && activeContact.external_userid === editingContact.external_userid) {
          setActiveContact(prev => ({ ...prev, nickname: newNickname.trim() }));
        }
        
        setShowNicknameModal(false);
      } else {
        throw new Error(response.data.msg || '备注更新失败');
      }
    } catch (error) {
      console.error('更新备注失败:', error);
      showAlert(error.message || '备注更新失败，请重试');
    } finally {
      setIsUpdatingNickname(false);
    }
  };

  // 新增：初始化状态函数
  const initializeStatus = useCallback(async () => {
    try {
      // 从localStorage获取保存的状态
      const savedStatus = localStorage.getItem('kefuStatus');
      
      if (savedStatus) {
        // 如果本地有保存状态，使用保存的状态
        setStatus(savedStatus);
      } else {
        // 否则设置为默认在线状态
        setStatus('online');
        localStorage.setItem('kefuStatus', 'online');
      }

      // 确保后端状态与本地一致
      await axios.post('https://scrm.ihuizhua.cn/kefu/update-status', {
        username: localStorage.getItem('username'),
        status: savedStatus || 'online'
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
    } catch (error) {
      console.error('状态初始化失败:', error);
      // 出错时设置为在线状态
      setStatus('online');
      localStorage.setItem('kefuStatus', 'online');
    }
  }, []);

  // 修改：切换在线状态函数 - 支持三种状态
  const updateStatus = async (newStatus) => {
    // 保存到localStorage
    localStorage.setItem('kefuStatus', newStatus);
    setStatus(newStatus);
    
    try {
      // 发送请求到后端更新状态
      await axios.post('https://scrm.ihuizhua.cn/kefu/update-status', {
        username: localStorage.getItem('username'),
        status: newStatus
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
    } catch (error) {
      console.error('状态更新失败:', error);
      // 如果请求失败，恢复之前的状态
      const lastStatus = localStorage.getItem('kefuStatus') || 'online';
      setStatus(lastStatus);
      showAlert('状态更新失败，请重试');
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // 添加文档类型的MIME类型
    const validTypes = [
      'image/jpg', 'image/jpeg', 'image/png', 'image/gif', 
      'video/mp4', 'video/webm', 'audio/mpeg', 'audio/ogg', 'audio/wav',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.addin.macroEnabled.12',
      'text/plain'
    ];

    const maxSize = 10 * 1024 * 1024; // 10MB

    if (!validTypes.includes(selectedFile.type)) {
      showAlert('请选择图片(jpg/png/gif)、视频(mp4/webm)、音频(mp3/wav/ogg)或文档(doc/docx/xls/xlsx/csv)文件');
      return;
    }

    if (selectedFile.size > maxSize) {
      showAlert('超出上传文件最大限制,最大上传10MB!');
      return;
    }

    // 只对图片文件显示预览
    if (selectedFile.type.startsWith('image/')) {
      setPreviewImageFile(selectedFile);
      setPreviewImage(URL.createObjectURL(selectedFile));
      setShowPreviewModal(true);
    } else {
      // 非图片文件直接上传
      handleUpload(selectedFile);
      
      // 重置文件输入
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }

    //setFile(selectedFile);
    //handleUpload(selectedFile)
  };

  // 新增：确认发送图片
  const handleConfirmFileSend = async () => {
    if (!previewImageFile) return;
    
    try {
      await handleUpload(previewImageFile);
      setShowPreviewModal(false);
      setPreviewImage(null);
      setPreviewImageFile(null);
      
      // 重置文件输入
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('文件发送失败:', error);
      showAlert('文件发送失败，请重试');
    }
  };

  // 新增：取消发送图片
  const handleCancelImageSend = () => {
    setShowPreviewModal(false);
    setPreviewImage(null);
    setPreviewImageFile(null);
    
    // 重置文件输入
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // 格式化时间显示
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
  };

  // 可靠且兼容的解析方式
  const getTimestampFromString = (datetimeStr) => {
    // 替换空格为T以符合ISO格式
    const isoFormatted = datetimeStr.replace(" ", "T");
    const date = new Date(isoFormatted);
    
    // 验证日期有效性
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }
    
    return date.getTime() / 1000;
  };

  // 获取快捷回复话术
  const fetchQuickReplies = useCallback(async () => {
    try {
      const resp = await axios.post('https://scrm.ihuizhua.cn/kefu/get-quick-replies', {
        username: localStorage.getItem('username')
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      
      setQuickReplies(resp.data);
      setActiveCategory(resp.data[0].category);
    } catch (error) {
      console.error('获取快捷回复失败:', error);
      const fallbackData = [
        {
          "category": "默认分类",
          "replies": ["您好！", "请问有什么可以帮您？"]
        }
      ];
      setQuickReplies(fallbackData);
      setActiveCategory(fallbackData[0].category);
    }
  }, []);

  // 在登录后获取快捷回复
  useEffect(() => {
    if (isLoggedIn) {
      initializeStatus();
      fetchQuickReplies();
    }
  }, [isLoggedIn, fetchQuickReplies, initializeStatus]);

  // 在页面加载时恢复最后阅读时间
  useEffect(() => {
    const savedLastReadTimes = localStorage.getItem('lastReadTimes');
    if (savedLastReadTimes) {
      setLastReadTimes(JSON.parse(savedLastReadTimes));
    }
  }, []);

  // 处理快捷回复点击
  const handleQuickReplyClick = (reply) => {
    if (!activeContact) return;
    
    const contactId = activeContact.external_userid;
    const currentCount = getCurrentContactCount();
    
    // 检查连续发送限制
    // if (currentCount >= 5) {
    //   showAlert(
    //     '发送限制', 
    //     `您已连续向 ${activeContact.nickname} 发送了 ${currentCount} 条消息。请等待用户回复后再继续发送。`
    //   );
    //   return;
    // }
    
    // 获取当前输入内容
    const currentInput = messageInputs[contactId] || '';
    
    // 将快捷回复添加到当前输入内容
    // 如果有现有内容，则在回复前添加换行
    const newInput = currentInput 
      ? `${currentInput}\n${reply}` 
      : reply;

    // 更新状态
    setMessageInputs(prev => ({
      ...prev,
      [contactId]: newInput
    }));

    //setMessageInput(text);
    // 聚焦到输入框
    setTimeout(() => {
      const textarea = document.querySelector('.message-input-container textarea');
      if (textarea) {
        textarea.focus();
        // 将光标移动到末尾
        textarea.selectionStart = textarea.selectionEnd = newInput.length;
      }
    }, 0);
  };

  // 更新输入内容时，更新特定联系人的状态
  const handleInputChange = (e) => {
    if (!activeContact) return;
    
    setMessageInputs(prev => ({
      ...prev,
      [activeContact.external_userid]: e.target.value
    }));
  };

  // 动态获取联系人数据（增量获取）
  const fetchContacts = useCallback(async () => {
    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/getContactlistReal', {
        username: localStorage.getItem('username'),
        last_time: lastContactTime
      }, {
        headers: { 
          'Authorization': `Bearer ${localStorage.getItem('authToken')}` 
        }
      });

      if (response.data.users && response.data.users.length > 0) {
        const maxTime = Math.max(...response.data.users.map(c => getTimestampFromString(c.send_time)));
        setLastContactTime(maxTime);
      }

      setContacts(prevContacts => {
        // 创建映射以快速更新已有联系人
        const prevContactsMap = new Map(
          prevContacts.map(contact => [contact.external_userid, contact])
        );
        
        // 合并新旧联系人
        const mergedContacts = [
          ...prevContacts,
          ...response.data.users.filter(
            newContact => !prevContactsMap.has(newContact.external_userid)
          )
        ].map(contact => {
          const newData = response.data.users.find(
            nc => nc.external_userid === contact.external_userid
          );
          
          // 如果有新数据，合并更新
          return newData 
            ? { 
                ...contact, 
                ...newData,
                unread: newData.unread || contact.unread || 0
              }
            : contact;
        });

        // 按 send_time 倒序排序
        return mergedContacts.sort((a, b) => {
          const timeA = getTimestampFromString(a.send_time);
          const timeB = getTimestampFromString(b.send_time);
          return timeB - timeA; // 降序排序（最新在前）
        });
      });
    } catch (error) {
      console.error('获取联系人失败:', error);
    }
  }, [lastContactTime]);

  // 处理关闭会话
  const handleCloseSession = async () => {
    if (!activeContact) return;
    const contactId = activeContact.external_userid;
    
    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/colse-session', {
        username: localStorage.getItem('username'),
        open_kfid: activeContact.open_kfid,
        external_userid: activeContact.external_userid,
        session_id: activeContact.session_id,
        qiwei_userid: activeContact.qiwei_userid
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      if (response.data.code) {
        // 从联系人列表中移除当前联系人
        setContacts(prevContacts => 
          prevContacts.filter(contact => 
            contact.external_userid !== activeContact.external_userid
          )
        );

        // 清除该联系人的计数
        setContinuousSendCount(prev => {
          const newCounts = {...prev};
          delete newCounts[contactId];
          return newCounts;
        });
        
        // 清空当前会话
        setActiveContact(null);
        setMessages([]);
        setShowCloseSessionConfirm(false);
        
        // 如果是移动端，则隐藏聊天窗口
        if (isMobileView) {
          setShowChat(false);
        }

        showAlert('会话关闭', `已成功关闭与 ${activeContact.nickname} 的会话`);
      } else {
        showAlert(response.data.msg);
      }
    } catch (error) {
      console.error('关闭会话失败:', error);
      showAlert('关闭会话失败:', error);
    }
  };

  // 动态获取消息（增量获取）
  const fetchMessages = useCallback(async (isInitial = false) => {
    if (!activeContact) return;

    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/getUserChatMsgs', {
        username: localStorage.getItem('username'),
        open_kfid: activeContact.open_kfid,
        external_userid: activeContact.external_userid,
        session_id: activeContact.session_id,
        is_all: isInitial ? 1 : 0,
        last_send_time: lastMessageTime
      },{
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      if (response.data.data && response.data.data.length > 0) {
        const formattedMessages = response.data.data.map(msg => ({
          id: msg.id,
          from: msg.from,
          sender: msg.from === "user" ? activeContact.nickname : activeContact.kefu_name,
          external_userid: msg.external_userid,
          text: msg.content,
          url: msg.media_url || msg.content,
          time: formatTime(msg.send_time),
          name: msg.from === "user" ? activeContact.nickname : activeContact.kefu_name,
          avatar: msg.from === "user" ? activeContact.avatar : activeContact.kefu_avatar,
          type: msg.msg_type,
          send_time: msg.send_time
        }));

        const latestMessage = formattedMessages[formattedMessages.length - 1];
        const maxTime = Math.max(...response.data.data.map(m => m.send_time));
        setLastMessageTime(maxTime);

        if (isInitial) {
          setMessages(formattedMessages);
          resetCurrentContactCount();
        } else {
          // 只处理消息合并，不处理未读计数
          setMessages(prev => {
            const newMessages = formattedMessages.filter(newMsg => 
              !prev.some(existingMsg => existingMsg.id === newMsg.id)
            );
            return [...prev, ...newMessages];
          });

          // 在setMessages外部单独处理未读计数
          const userMessages = formattedMessages.filter(msg => msg.from === 'user');

          if (userMessages.length > 0) {
            let messageContent = latestMessage.text;
            if (latestMessage.type === 'image') {
              messageContent = '[图片]';
            } else if (latestMessage.type === 'video') {
              messageContent = '[视频]';
            } else if (latestMessage.type === 'audio') {
              messageContent = '[语音]';
            }

            // 使用函数式更新确保基于最新状态
            setContacts(prevContacts => {
              const updatedContacts = prevContacts.map(contact => 
                contact.external_userid === activeContact.external_userid 
                  ? { 
                      ...contact, 
                      unread: (contact.unread || 0) + userMessages.length,
                      content: messageContent,
                      send_time: latestMessage.time,
                    }
                  : contact
              );
              return updatedContacts.sort((a, b) => {
                const timeA = getTimestampFromString(a.send_time);
                const timeB = getTimestampFromString(b.send_time);
                return timeB - timeA;
              });
            });
            
            resetCurrentContactCount();
          }
        }
      }
      setInit(true);
      setError(null);
    } catch (error) {
      console.error('获取消息失败:', error);
      showAlert('错误', '获取消息失败，请稍后重试');
    }
  }, [activeContact, lastMessageTime, resetCurrentContactCount, showAlert]);

  // 获取历史聊天记录
  const fetchHistoryMessages = useCallback(async () => {
    if (!activeContact) return;
    
    setIsHistoryLoading(true);
    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/getUserChatMsgs', {
        username: localStorage.getItem('username'),
        open_kfid: activeContact.open_kfid,
        external_userid: activeContact.external_userid,
        session_id: "",
        is_all: 1
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      const formattedMessages = response.data.data.map(msg => ({
        id: msg.id,
        from: msg.from,
        sender: msg.from === "user" ? activeContact.nickname : activeContact.kefu_name,
        text: msg.content,
        url: msg.media_url || msg.content,
        time: formatTime(msg.send_time),
        name: msg.from === "user" ? activeContact.nickname : activeContact.kefu_name,
        avatar: msg.from === "user" ? activeContact.avatar : activeContact.kefu_avatar,
        type: msg.msg_type
      }));

      setHistoryMessages(formattedMessages);
    } catch (error) {
      console.error('获取历史消息失败:', error);
    } finally {
      setIsHistoryLoading(false);
    }
  }, [activeContact]);

  // 打开历史记录弹窗
  const openHistoryModal = async () => {
    setShowHistoryModal(true);
    await fetchHistoryMessages();
  };

  // 在需要更新阅读时间的地方调用此逻辑
  const updateLastReadTime = (contact) => {
    // 1. 创建秒级时间戳
    const timestamp = Math.floor(Date.now() / 1000);
    
    // 2. 更新本地状态
    setLastReadTimes(prev => ({
      ...prev,
      [contact.external_userid]: timestamp
    }));
    
    // 3. 发送请求到后端
    axios.post('https://scrm.ihuizhua.cn/kefu/updateLastReadTimes', {
      username: localStorage.getItem('username'),
      external_userid: contact.external_userid,
      last_read_time: timestamp
    }, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(response => {
      console.log('最后阅读时间更新成功', response.data);
      // 可选的后续处理
    })
    .catch(error => {
      console.error('更新最后阅读时间失败:', error);
      // 错误处理（例如：恢复状态/显示错误信息）
      // 注意：根据业务需求决定是否回退本地状态
      setLastReadTimes(prev => ({
        ...prev,
        [contact.external_userid]: prev[contact.external_userid] // 回退到之前的值
      }));
    });
  };

  // 处理联系人点击 - 更新最后阅读时间
  const handleContactClick = (contact) => {
    // 保存当前联系人的计数器（如果有）
    if (activeContact) {
      const prevContactId = activeContact.external_userid;
      const prevCount = getCurrentContactCount();
      
      // 更新存储
      setContinuousSendCount(prev => ({
        ...prev,
        [prevContactId]: {
          count: prevCount,
          lastUpdate: Date.now()
        }
      }));
    }

    // 更新最后阅读时间
    updateLastReadTime(contact);
    
    // 清除未读消息
    setContacts(prev => prev.map(c => 
      c.external_userid === contact.external_userid ? {...c, unread: 0} : c
    ));
    
    setActiveContact(contact);
    setLastMessageTime(0); // 重置消息时间戳，重新加载全部消息

    // 初始化新联系人的计数器
    //resetCurrentContactCount();

    if (isMobileView) {
      setShowChat(true);
    }
  };

  // 设置定时器获取联系人和消息
  useEffect(() => {
    if (isLoggedIn) {
      // 初始加载联系人和消息
      //fetchContacts();
      if (activeContact) {
        fetchMessages(true); // 初始加载全部消息
      }

      let is_check = localStorage.getItem("is_check");
      let iFetchContactTimeststamp;
      let iFetchMessageTimestamp

      // 每10秒获取一次新联系人
      if(is_check == 1) {
        iFetchContactTimeststamp = 180000;
        iFetchMessageTimestamp = 60000;
      } else {
        iFetchContactTimeststamp = 10000;
        iFetchMessageTimestamp = 3000;
      }

      contactsIntervalRef.current = setInterval(fetchContacts, iFetchContactTimeststamp);
      
      // 每3秒获取一次新消息
      messagesIntervalRef.current = setInterval(() => {
        if (activeContact) {
          fetchMessages(); // 增量获取新消息
        }
      }, iFetchMessageTimestamp);
      
      return () => {
        clearInterval(contactsIntervalRef.current);
        clearInterval(messagesIntervalRef.current);
      };
    }
  }, [isLoggedIn, activeContact, fetchContacts, fetchMessages]);

  // 检查 localStorage 中的登录状态
  useEffect(() => {
    const savedUsername = localStorage.getItem('username');
    if (savedUsername) {
      setCurrentUser(savedUsername);
      setIsLoggedIn(true);
      fetchContacts();
    }
  }, [fetchContacts]);

  // 检查token是否过期
  useEffect(() => {
    const checkTokenExpiration = () => {
      const tokenExpiration = localStorage.getItem('tokenExpiration');
      if (tokenExpiration && new Date().getTime() > parseInt(tokenExpiration)) {
        handleLogout();
      }
    };

    checkTokenExpiration();
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);

  // 响应式设计
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      setIsMobileView(isMobile);
      
      if (!isMobile) {
        setShowChat(true);
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 设置默认联系人
  useEffect(() => {
    if (isLoggedIn && contacts.length > 0 && !isMobileView && !activeContact) {
      setActiveContact(contacts[0]);
    }
  }, [isLoggedIn, contacts, isMobileView, activeContact]);

  const handleLogout = async () => {
    clearInterval(contactsIntervalRef.current);
    clearInterval(messagesIntervalRef.current);

    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/logout', {
        username: localStorage.getItem('username')
      });
      
      if (response.data.code) {
      } else {
        showAlert(response.data.message || '退出登录失败');
        throw new Error(response.data.message || '退出登录失败');
      }
    } catch (err) {
      showAlert(err.response?.data?.message || err.message || '退出登录失败');
      setError(err.response?.data?.message || err.message || '退出登录失败');
    } finally {
      setIsLoading(false);
    }
    
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    localStorage.removeItem('avatar');
    localStorage.removeItem('kefu_name');
    localStorage.removeItem('is_check');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('kefuStatus');

    // 清除所有计数
    setContinuousSendCount({});
    localStorage.removeItem('continuousSendCount');

    setIsLoggedIn(false);
    setActiveContact(null);
    setUsername('');
    setPassword('');
    setLoginKefu('');
    setShowLogoutConfirm(false);
    setLastMessageTime(0);
    setLastContactTime(0);

    // 显示登出成功提示
    showAlert('登出成功', '您已成功登出系统');
  };

  // 显示退出确认对话框
  const confirmLogout = () => {
    setShowLogoutConfirm(true);
  };

  // 取消退出
  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  // 登录函数
  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!username.trim()) {
      setError('请输入用户名');
      return;
    }
    if (!password.trim()) {
      setError('请输入密码');
      return;
    }

    if (username.length < 3) {
      setError('用户名至少需要3个字符');
      return;
    }

    if (password.length < 6) {
      setError('密码至少需要6个字符');
      return;
    }
    
    setIsLoading(true);
    setError('');
    
    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/login', {
        username: username.trim(),
        password: password.trim()
      });
      
      if (response.data.success) {
        setIsLoggedIn(true);
        setCurrentUser(username);

        const expirationTime = new Date().getTime() + 8 * 60 * 60 * 1000;
        
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('username', username);
        localStorage.setItem('avatar', response.data.user.avatar);
        localStorage.setItem('kefu_name', response.data.user.kefu_name);
        localStorage.setItem('tokenExpiration', expirationTime.toString());
        localStorage.setItem('is_check', response.data.user.is_check);

        setLoginKefu(response.data.user);

        setContinuousSendCount({});
        localStorage.removeItem('continuousSendCount');

        // 确保状态初始化
        await initializeStatus();
        
        setTimeout(() => {
          handleLogout();
        }, 2 * 60 * 60 * 1000);
        
        fetchContacts();

        // 显示登录成功提示
        showAlert('登录成功', '欢迎回来!');
      } else {
        showAlert('登录失败', response.data.message || '用户名或密码错误');
        throw new Error(response.data.message || '登录失败');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || '登录失败');
      showAlert('错误', '登录失败，请检查网络连接');
    } finally {
      setIsLoading(false);
    }
  };

  // 在登录成功后设置当前联系人时初始化计数器
  useEffect(() => {
    if (contacts.length > 0 && !activeContact) {
      // 设置第一个联系人为当前联系人
      const firstContact = contacts[0];
      setActiveContact(firstContact);
      
      // 初始化计数器
      resetCurrentContactCount();
      
      // 清除未读消息
      setContacts(prev => prev.map(c => 
        c.external_userid === firstContact.external_userid ? {...c, unread: 0} : c
      ));
    }
  }, [contacts, activeContact, resetCurrentContactCount]);

  // 发送消息（不重新请求全部消息）
  const handleSendMessage = useCallback(async (text) => {
    if (!text.trim()) return;
    if (!activeContact) return;

    // 获取当前联系人的计数
    const currentCount = getCurrentContactCount();
    
    // 检查连续发送限制
    // if (currentCount >= 5) {
    //   showAlert(
    //     '发送限制', 
    //     `您已连续向 ${activeContact.nickname} 发送了 ${currentCount} 条消息。请等待用户回复后再继续发送。`
    //   );
    //   return;
    // }

    // 创建临时消息
    const tempMessage = {
      id: `temp-${Date.now()}`,
      from: 'artificial',
      sender: activeContact.kefu_name,
      text: text,
      content: text,
      time: formatTime(Math.floor(Date.now() / 1000)),
      name: activeContact.kefu_name,
      avatar: activeContact.kefu_avatar,
      type: 'text',
      send_time: Math.floor(Date.now() / 1000)
    };

    // 添加到消息列表
    setMessages(prev => [...prev, tempMessage]);
    
    // 保存当前联系人ID和输入内容，用于错误恢复
    const currentExternalUserId = activeContact.external_userid;
    const currentText = text;

    // 清空输入
    setMessageInputs(prev => ({
      ...prev,
      [currentExternalUserId]: ''
    }));

    try {
      // 发送消息到服务器
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/sendMsgToQiweiUser', {
        username: localStorage.getItem('username'),
        open_kfid: activeContact.open_kfid,
        external_userid: activeContact.external_userid,
        session_id: activeContact.session_id,
        qiwei_userid: activeContact.qiwei_userid,
        content: text
      },{
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      
      if (!response.data.id) {
        // 发送失败，移除临时消息并恢复输入
        setMessages(prev => prev.filter(msg => msg.id !== tempMessage.id));
        setMessageInputs(prev => ({
          ...prev,
          [currentExternalUserId]: currentText
        }));
        showAlert(response.data.msg);
        return;
      }

      // 更新当前联系人的计数（带时间戳）
      updateCurrentContactCount(currentCount + 1);

      // 更新临时消息
      setMessages(prev => prev.map(msg => 
        msg.id === tempMessage.id ? {
          ...msg,
          id: response.data.id,
          send_time: response.data.send_time
        } : msg
      ));
      
      // 更新最后消息时间
      if (response.data.send_time > lastMessageTime) {
        setLastMessageTime(response.data.send_time);
      }

      // ============= 新增代码：更新联系人列表 =============
      // 1. 创建格式化后的发送时间字符串
      const formattedSendTime = formatTime(response.data.send_time);
      
      // 2. 更新联系人列表
      setContacts(prevContacts => {
        // 创建联系人映射以便快速查找
        const contactsMap = new Map(prevContacts.map(c => [c.external_userid, c]));
        
        // 更新当前联系人
        const updatedContact = {
          ...activeContact,
          content: text, // 更新最后一条消息内容
          send_time: formattedSendTime, // 更新发送时间
          unread: 0 // 重置未读消息数为0
        };
        
        // 更新映射中的联系人
        contactsMap.set(activeContact.external_userid, updatedContact);
        
        // 转换为数组并排序
        return Array.from(contactsMap.values()).sort((a, b) => {
          const timeA = getTimestampFromString(a.send_time);
          const timeB = getTimestampFromString(b.send_time);
          return timeB - timeA; // 降序排序（最新在前）
        });
      });

      // 3. 更新当前活跃联系人状态
      setActiveContact(prev => 
        prev && prev.external_userid === activeContact.external_userid 
          ? { ...prev, unread: 0 } 
          : prev
      );
      
      // 4. 更新最后阅读时间
      updateLastReadTime(activeContact);
      // ============= 新增代码结束 =============
      
      setTimeout(scrollToBottom, 0);
    } catch (error) {
      console.error('发送消息失败:', error);
      // 发送失败，移除临时消息并恢复输入
      setMessages(prev => prev.filter(msg => msg.id !== tempMessage.id));
      setMessageInputs(prev => ({
        ...prev,
        [currentExternalUserId]: currentText
      }));
      showAlert('消息发送失败，请重试');
    }
  }, [activeContact, lastMessageTime, scrollToBottom, updateLastReadTime, getCurrentContactCount, updateCurrentContactCount]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const text = e.target.value.trim();
      if (text) {
        handleSendMessage(text);
      }
    }
  };

  // 上传文件（不重新请求全部消息）
  const handleUpload = useCallback(async (e) => {
    if (!e) return;
    if (!activeContact) return;

    // 获取当前联系人的计数
    const currentCount = getCurrentContactCount();
    
    // 检查连续发送限制
    // if (currentCount >= 5) {
    //   showAlert(
    //     '发送限制', 
    //     `您已连续向 ${activeContact.nickname} 发送了 ${currentCount} 条消息。请等待用户回复后再继续发送。`
    //   );
    //   return;
    // }

    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', e);
    formData.append('username', localStorage.getItem('username'));
    formData.append('sender', activeContact.kefu_name);
    formData.append('receiver', activeContact.nickname);
    formData.append('open_kfid', activeContact.open_kfid);
    formData.append('external_userid', activeContact.external_userid);
    formData.append('session_id', activeContact.session_id);
    formData.append('qiwei_userid', activeContact.qiwei_userid);

    // 根据文件类型设置消息内容
    let messageContent = '[文件]';
    let fileType = 'file';
    if (e.type.startsWith('image')) {
      messageContent = '[图片]';
      fileType = 'image';
    } else if (e.type.startsWith('video')) {
      messageContent = '[视频]';
      fileType = 'video';
    } else if (e.type.startsWith('audio')) {
      messageContent = '[语音]';
      fileType = 'voice';
    }

    formData.append('file_type', fileType);

    // 创建临时文件消息
    const tempFileMessage = {
      id: `temp-${Date.now()}`,
      from: 'artificial',
      sender: activeContact.kefu_name,
      text: URL.createObjectURL(e), // 临时本地URL
      content: URL.createObjectURL(e),
      time: formatTime(Math.floor(Date.now() / 1000)),
      name: activeContact.kefu_name,
      avatar: activeContact.kefu_avatar,
      type: fileType,
      send_time: Math.floor(Date.now() / 1000) // 临时时间戳
    };

    setMessages(prev => [...prev, tempFileMessage]);
    setFile(null);

    try {
      const response = await axios.post('https://scrm.ihuizhua.cn/kefu/upload-media', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });

      if (response.data.code === 1) {
        // 上传成功后增加计数
        // 更新当前联系人的计数
        updateCurrentContactCount(currentCount + 1);

        // 更新临时消息为正式消息
        setMessages(prev => prev.map(msg => 
          msg.id === tempFileMessage.id ? {
            ...msg,
            id: response.data.id,
            text: response.data.media_url,
            content: response.data.media_url,
            send_time: response.data.send_time
          } : msg
        ));
        
        // 更新最后消息时间
        if (response.data.send_time > lastMessageTime) {
          setLastMessageTime(response.data.send_time);
        }

        // ============= 新增代码：更新联系人列表 =============
        // 1. 创建格式化后的发送时间字符串
        const formattedSendTime = formatTime(response.data.send_time);
        
        // 2. 更新联系人列表
        setContacts(prevContacts => {
          // 创建联系人映射以便快速查找
          const contactsMap = new Map(prevContacts.map(c => [c.external_userid, c]));
          
          // 更新当前联系人
          const updatedContact = {
            ...activeContact,
            content: messageContent, // 更新最后一条消息内容
            send_time: formattedSendTime, // 更新发送时间
            unread: 0 // 重置未读消息数为0
          };
          
          // 更新映射中的联系人
          contactsMap.set(activeContact.external_userid, updatedContact);
          
          // 转换为数组并排序
          return Array.from(contactsMap.values()).sort((a, b) => {
            const timeA = getTimestampFromString(a.send_time);
            const timeB = getTimestampFromString(b.send_time);
            return timeB - timeA; // 降序排序（最新在前）
          });
        });

        // 3. 更新当前活跃联系人状态
        setActiveContact(prev => 
          prev && prev.external_userid === activeContact.external_userid 
            ? { ...prev, unread: 0 } 
            : prev
        );
        
        // 4. 更新最后阅读时间
        updateLastReadTime(activeContact);
        // ============= 新增代码结束 =============
        
        setTimeout(scrollToBottom, 0);
      } else {
        throw new Error(response.data.msg || '文件上传失败');
      }
    } catch (error) {
      console.error('上传失败:', error);
      // 上传失败，移除临时消息
      setMessages(prev => prev.filter(msg => msg.id !== tempFileMessage.id));
      showAlert(error.message);
    } finally {
      setIsUploading(false);
    }
  },[activeContact, lastMessageTime, scrollToBottom, updateLastReadTime, getCurrentContactCount, updateCurrentContactCount]);

  // 添加粘贴事件处理函数
  const handlePaste = useCallback((e) => {
    // 确保有活跃联系人
    if (!activeContact) return;

    // 检查连续发送限制
    const currentCount = getCurrentContactCount();
    
    // 检查连续发送限制
    // if (currentCount >= 5) {
    //   showAlert(
    //     '发送限制', 
    //     `您已连续向 ${activeContact.nickname} 发送了 ${currentCount} 条消息。请等待用户回复后再继续发送。`
    //   );
    //   return;
    // }
    
    // 获取剪贴板数据
    const items = e.clipboardData.items;
    if (!items) return;
    
    // 遍历剪贴板项
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      
      // 检查是否是图片类型
      if (item.type.indexOf('image') !== -1) {
        // 阻止默认粘贴行为
        e.preventDefault();
        
        // 获取图片文件
        const blob = item.getAsFile();
        if (!blob) continue;
        
        // 创建文件名（使用时间戳）
        const extension = blob.type.split('/')[1] || 'png';
        const fileName = `screenshot-${Date.now()}.${extension}`;
        
        // 创建文件对象
        const file = new File([blob], fileName, { type: blob.type });

        // 设置预览状态（与文件选择相同）
        setPreviewImageFile(file);
        setPreviewImage(URL.createObjectURL(blob));
        setShowPreviewModal(true);
        break;
        
        // 调用上传函数
        //handleUpload(file);
        //break;
      }
    }
  }, [activeContact, handleUpload]);

  // 为输入区域添加粘贴事件监听
  useEffect(() => {
    const inputArea = document.querySelector('.chat-input-area');
    if (inputArea) {
      inputArea.addEventListener('paste', handlePaste);
      return () => {
        inputArea.removeEventListener('paste', handlePaste);
      };
    }
  }, [handlePaste]);

  const handleBackToContacts = () => {
    setShowChat(false);
    setActiveContact(null);
  };

  if (!isLoggedIn) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>咪噜客服系统</h1>
            <p>高效沟通，协同办公</p>
          </div>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">账号</label>
              <input 
                type="text" 
                id="username" 
                placeholder="请输入账号" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">密码</label>
              <input 
                type="password" 
                id="password" 
                placeholder="请输入密码" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required 
              />
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button 
              type="submit" 
              className="login-button"
              disabled={isLoading}
            >
              {isLoading ? '登录中...' : '登录'}
            </button>
          </form>
          <div className="login-footer">
            <p>© 2025 咪噜客服系统 - 让工作更高效</p>
          </div>
        </div>
      </div>
    );
  }

  // 联系人项组件
  const ContactItem = ({ 
    contact, 
    activeContact, 
    handleContactClick, 
    pinnedContacts,
    pinContact,
    unpinContact
  }) => {
    const isPinned = pinnedContacts.includes(contact.external_userid);
    
    return (
      <div 
        className={`contact-item ${activeContact?.external_userid === contact.external_userid ? 'active' : ''}`}
        onClick={() => handleContactClick(contact)}
      >
        <img className="contact-avatar" src={contact.avatar} alt={contact.nickname} />
        <div className="contact-info">
          <div className="contact-content">
            <div className="contact-meta">
              <div className="contact-name">{contact.nickname}</div>
              <div>
              {contact.unread > 0 && (
                <div className="unread-count">{contact.unread}</div>
              )}

              {/* 置顶/取消置顶按钮 */}
              <div 
                className={`pin-button ${isPinned ? 'pinned' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (isPinned) {
                    unpinContact(contact.external_userid);
                  } else {
                    pinContact(contact.external_userid);
                  }
                }}
                title={isPinned ? "取消置顶" : "置顶会话"}
              >
                {isPinned ? '📌' : '📍'}
              </div>
              </div>
            </div>
            <div className="contact-time">{contact.send_time}</div>
          </div>
          <div className="contact-lastmsg">{contact.content}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="app-container">
      {/* 通用弹窗 alert 组件 */}
      {alertInfo.show && (
        <div className="alert-modal-overlay">
          <div className="alert-modal">
            <div className="alert-modal-content">
              <h3>{alertInfo.title}</h3>
              <p>{alertInfo.message}</p>
            </div>
            <div className="alert-modal-actions">
              {alertInfo.showCancel && (
                <button 
                  className="cancel-button"
                  onClick={() => {
                    if (alertInfo.onCancel) alertInfo.onCancel();
                    closeAlert();
                  }}
                >
                  取消
                </button>
              )}
              <button 
                className="confirm-button"
                onClick={() => {
                  if (alertInfo.onConfirm) alertInfo.onConfirm();
                  closeAlert();
                }}
              >
                {alertInfo.showCancel ? '确认' : '知道了'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 图片预览弹窗 */}
      {showPreviewModal && previewImage && (
        <div className="preview-modal-overlay">
          <div className="preview-modal">
            <h3>预览图片</h3>
            <div className="preview-image-container">
              <img src={previewImage} alt="预览图片" />
            </div>
            <div className="preview-actions">
              <button 
                className="cancel-button"
                onClick={handleCancelImageSend}
              >
                取消
              </button>
              <button 
                className="confirm-button"
                onClick={handleConfirmFileSend}
                disabled={isUploading}
              >
                {isUploading ? '发送中...' : '确认发送'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 备注编辑弹窗 */}
      {showNicknameModal && (
        <div className="nickname-modal-overlay">
          <div className="nickname-modal">
            <h3>修改备注名</h3>
            <input
              type="text"
              value={newNickname}
              onChange={(e) => setNewNickname(e.target.value)}
              placeholder="请输入新的备注名"
              className="nickname-input"
              autoFocus
            />
            <div className="modal-buttons">
              <button 
                className="cancel-button"
                onClick={() => setShowNicknameModal(false)}
                disabled={isUpdatingNickname}
              >
                取消
              </button>
              <button 
                className="confirm-button"
                onClick={handleConfirmNickname}
                disabled={isUpdatingNickname || !newNickname.trim()}
              >
                {isUpdatingNickname ? '保存中...' : '保存'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showLogoutConfirm && (
        <div className="logout-confirm-overlay">
          <div className="logout-confirm-box">
            <h3>确认退出</h3>
            <p>确定要退出当前账号吗？</p>
            <div className="confirm-buttons">
              <button className="cancel-button" onClick={cancelLogout}>取消</button>
              <button className="confirm-button" onClick={handleLogout}>确定退出</button>
            </div>
          </div>
        </div>
      )}

      {showCloseSessionConfirm && (
        <div className="logout-confirm-overlay">
          <div className="logout-confirm-box">
            <h3>确认关闭会话</h3>
            <p>确定要关闭与{activeContact?.nickname}的会话吗？</p>
            <div className="confirm-buttons">
              <button className="cancel-button" onClick={() => setShowCloseSessionConfirm(false)}>取消</button>
              <button className="confirm-button" onClick={handleCloseSession}>确定关闭</button>
            </div>
          </div>
        </div>
      )}

      <div className={`sidebar ${isMobileView && showChat ? 'hidden-on-mobile' : ''}`}>
        <div className="sidebar-header">
          <div className="user-info">
            <div className="user-avatar">
              <img className="message-avatar" src={localStorage.getItem('avatar')} alt={localStorage.getItem('kefu_name')} />
            </div>
            <div className="user-name">{localStorage.getItem('kefu_name')}</div>
            {/* 修改为状态选择器 */}
            <div className="status-selector">
              <select
                value={status}
                onChange={(e) => updateStatus(e.target.value)}
                className={`status-toggle ${status}`}
              >
                <option value="online">在线</option>
                <option value="hangup">挂起</option>
                <option value="outline">离线</option>
              </select>
            </div>
          </div>
          <div className="search-box">
            <input type="text" placeholder="搜索联系人..." 
              onChange={input => {
                if (input.target.value.length === 0) {
                  setFilterList([]);
                  return;
                }
                const filterList = contacts.filter(e => 
                  e.nickname.includes(input.target.value)
                );
                setFilterList(filterList.length > 0 ? filterList : contacts);
              }}
            />
            <button className="search-button">🔍</button>
          </div>
        </div>
        
        <div className="contact-list">
          {/* 置顶联系人部分 */}
          {pinned.length > 0 && (
            <>
              <div className="pinned-header">置顶会话</div>
              {pinned.map((contact, index) => (
                <ContactItem 
                  key={`pinned-${contact.external_userid}-${index}`}
                  contact={contact}
                  activeContact={activeContact}
                  handleContactClick={handleContactClick}
                  pinnedContacts={pinnedContacts}
                  pinContact={pinContact}
                  unpinContact={unpinContact}
                />
              ))}
            </>
          )}

          {/* 普通联系人部分 */}
          {unpinned.length > 0 && (
            <>
              {pinned.length > 0 && <div className="unpinned-header">所有会话</div>}
              {unpinned.map((contact, index) => (
                <ContactItem 
                  key={`unpinned-${contact.external_userid}-${index}`}
                  contact={contact}
                  activeContact={activeContact}
                  handleContactClick={handleContactClick}
                  pinnedContacts={pinnedContacts}
                  pinContact={pinContact}
                  unpinContact={unpinContact}
                />
              ))}
            </>
          )}
        </div>
        
        <div className="sidebar-footer">
          <button className="logout-button" onClick={confirmLogout}>
            <span className="logout-icon">🚪</span> 退出登录
          </button>
        </div>
      </div>

      {showHistoryModal && (
        <div className="history-modal-overlay">
          <div className="history-modal">
            <div className="history-modal-header">
              <h3>{activeContact?.nickname} 的历史聊天记录</h3>
              <button 
                className="close-button"
                onClick={() => setShowHistoryModal(false)}
              >
                ×
              </button>
            </div>
            
            <div className="history-messages-container">
              {isHistoryLoading ? (
                <div className="loading-indicator">加载中...</div>
              ) : (
                <div className="history-messages">
                  {historyMessages.map(msg => (
                    <div 
                      key={msg.id} 
                      className={`message ${msg.from === 'user' ? 'received' : 'sent'}`}
                    >
                      {msg.sender !== 'me' && (
                        <img 
                          className="message-avatar" 
                          src={msg.avatar} 
                          alt={msg.name} 
                        />
                      )}
                      
                      <div className="message-content">
                        {msg.sender !== 'me' && (
                          <div className="message-sender">{msg.name}</div>
                        )}
                        
                        {msg.type === 'text' && (
                          <div className="message-bubble">
                            <div className="message-text">{msg.text}</div>
                            <div className="message-time">{msg.time}</div>
                          </div>
                        )}
                        
                        {msg.type === 'image' && (
                          <div className="message-bubble">
                            <div className="message-image" onClick={()=>{window.open(msg.text, '_blank')}}>
                              <img src={msg.text} alt="发送的图片" />
                            </div>
                            <div className="message-time">{msg.time}</div>
                          </div>
                        )}

                        {msg.type === 'voice' && (
                          <div className="message-bubble">
                            <div className="message-voice">
                              <audio src={msg.text} controls controlsList="nodownload" style={{ height: '20px', width: '250px' }} preload="auto"/>
                            </div>
                            <div className="message-time">{msg.time}</div>
                          </div>
                        )}

                        {/* 添加文档类型消息渲染 */}
                        {msg.type === 'file' && (
                          <div className="message-bubble">
                            <div className="message-file" onClick={() => window.open(msg.text, '_blank')}>
                              <div className="file-icon">📄</div>
                              <div className="file-info">
                                <div className="file-name">
                                  {msg.fileName || msg.text.split('/').pop()}
                                </div>
                                <div className="file-type">
                                  {msg.fileType || '文档'}
                                </div>
                              </div>
                            </div>
                            <div className="message-time">{msg.time}</div>
                          </div>
                        )}
                        
                        {msg.type === 'video' && (
                          <div className="message-bubble">
                            <div className="message-video">
                              <video controls>
                                <source src={msg.text} type="video/mp4" />
                                您的浏览器不支持视频播放
                              </video>
                            </div>
                            <div className="message-time">{msg.time}</div>
                          </div>
                        )}
                      </div>
                      
                      {msg.sender === 'me' && (
                        <img 
                          className="message-avatar" 
                          src={msg.avatar} 
                          alt={msg.name} 
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <div className="history-modal-footer">
              <button 
                className="close-button"
                onClick={() => setShowHistoryModal(false)}
              >
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div className={`chat-container ${isMobileView && !showChat ? 'hidden-on-mobile' : ''}`}>
        {activeContact ? (
          <>
            <div className="chat-header">
              {isMobileView && (
                <button className="back-button" onClick={handleBackToContacts}>
                  &lt; 返回
                </button>
              )}
              <div className="chat-contact">
                <img className="chat-avatar" src={activeContact.avatar} alt={activeContact.nickname} />
                <div className="chat-name" onClick={() => openNicknameModal(activeContact)}>{activeContact.nickname}</div>
              </div>
              <div className="chat-actions">
                <button 
                  className="history-button"
                  onClick={openHistoryModal}
                  title="历史会话"
                >
                  历史会话
                </button>

                <button 
                  className="close-session-button"
                  onClick={() => setShowCloseSessionConfirm(true)}
                  title="关闭会话"
                >
                  关闭会话
                </button>
              </div>
            </div>
            
            <div className="chat-content-wrapper">
              {init ? (
                <div className="messages-container flex-grow" ref={chatWindowRef}>
                  <div className="chat-messages">
                    {messages.map(msg => (
                      <div 
                        key={msg.id} 
                        className={`message ${msg.from === 'user' ? 'received' : 'sent'}`}
                      >
                        {msg.sender !== 'me' && (
                          <img 
                            className="message-avatar" 
                            src={msg.avatar} 
                            alt={msg.name} 
                          />
                        )}
                        
                        <div className="message-content">
                          {msg.sender !== 'me' && (
                            <div className="message-sender">{msg.name}</div>
                          )}
                          
                          {msg.type === 'text' && (
                            <div className="message-bubble">
                              <div className="message-text">{convertChineseToUnicode(msg.text)}</div>
                              <div className="message-time">{msg.time}</div>
                            </div>
                          )}
                          
                          {msg.type === 'image' && (
                            <div className="message-bubble">
                              <div className="message-image" onClick={()=>{window.open(msg.text, '_blank')}}>
                                <img src={msg.text} alt="发送的图片" />
                              </div>
                              <div className="message-time">{msg.time}</div>
                            </div>
                          )}

                          {msg.type === 'voice' && (
                            <div className="message-bubble">
                              <div className="message-voice">
                                <audio src={msg.text} controls controlsList="nodownload" style={{ height: '20px', width: '250px' }} preload="auto"/>
                              </div>
                              <div className="message-time">{msg.time}</div>
                            </div>
                          )}

                          {/* 添加文档类型消息渲染 */}
                          {msg.type === 'file' && (
                            <div className="message-bubble">
                              <div className="message-file" onClick={() => window.open(msg.text, '_blank')}>
                                <div className="file-icon">📄</div>
                                <div className="file-info">
                                  <div className="file-name">
                                    {msg.fileName || msg.text.split('/').pop()}
                                  </div>
                                  <div className="file-type">
                                    {msg.fileType || '文档'}
                                  </div>
                                </div>
                              </div>
                              <div className="message-time">{msg.time}</div>
                            </div>
                          )}
                          
                          {msg.type === 'video' && (
                            <div className="message-bubble">
                              <div className="message-video">
                                <video controls>
                                  <source src={msg.text} type="video/mp4" />
                                  您的浏览器不支持视频播放
                                </video>
                              </div>
                              <div className="message-time">{msg.time}</div>
                            </div>
                          )}
                        </div>
                        
                        {msg.sender === 'me' && (
                          <img 
                            className="message-avatar" 
                            src={msg.avatar} 
                            alt={msg.name} 
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : <></>}
              
              <div className="quick-replies-sidebar">
                <div className="quick-replies-header">
                  <h3>快捷回复</h3>
                </div>
                
                <div className="category-tabs">
                  {quickReplies.map((categoryGroup) => (
                    <button
                      key={categoryGroup.category}
                      className={`category-tab ${activeCategory === categoryGroup.category ? 'active' : ''}`}
                      onClick={() => setActiveCategory(categoryGroup.category)}
                    >
                      {categoryGroup.category}
                    </button>
                  ))}
                </div>
                
                <div className="quick-replies-list">
                  {quickReplies
                    .find(group => group.category === activeCategory)
                    ?.replies.map((reply, index) => (
                      <div 
                        key={index}
                        className="quick-reply-item"
                        onClick={() => handleQuickReplyClick(reply)}
                      >
                        {reply}
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            
            <div className="chat-input-area" style={{ minHeight: '60px' }}>
              {/* 新增顶部拖动手柄 */}
              <div 
                ref={topResizeHandleRef} 
                className="top-resize-handle" 
                onMouseDown={handleTopResizeMouseDown}
                title="拖动调整高度"
              >
                <div className="drag-indicator"></div>
              </div>

              <div className="input-actions">
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept="image/*,video/*,audio/*,.doc,.docx,.xls,.xlsx,.csv,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  style={{ display: 'none' }}
                />
                <button
                  type="button"
                  onClick={() => {
                    fileInputRef.current.value = ''
                    fileInputRef.current.click()
                  }}
                  className="attach-button"
                >
                  📎
                </button>
              </div>
              <div className="message-input-container" style={{ height: `${currentInputHeight}px` }}>
                <textarea 
                  value={currentMessageInput} 
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                  placeholder="输入消息..."
                  rows="1"
                />
                <div ref={resizeHandleRef} className="resize-handle" onMouseDown={handleResizeMouseDown}></div>
              </div>

              {/* 添加表情按钮 */}
              <button 
                className="emoji-button"
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                title="表情"
              >
                😊
              </button>
              
              {/* 表情选择器 */}
              {showEmojiPicker && (
                <div className="emoji-picker" ref={emojiPickerRef}>
                  <div className="emoji-picker-header">
                    <h4>微信表情</h4>
                    <button 
                      className="close-emoji-picker"
                      onClick={() => setShowEmojiPicker(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="emoji-grid">
                    {Object.entries(wechatEmojiMap).map(([key, emoji]) => (
                      <div 
                        key={key}
                        className="emoji-item"
                        onClick={() => insertEmoji(key)}
                        title={key}
                      >
                        {emoji}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <button 
                className="send-button" 
                onClick={()=>handleSendMessage(currentMessageInput)}
                disabled={!currentMessageInput.trim()}
              >
                发送
              </button>
            </div>
          </>
        ) : (
          <div className="chat-placeholder">
            <div className="placeholder-content">
              <h2>咪噜客服系统</h2>
              <p>选择联系人开始聊天</p>
              <div className="features">
                <div className="feature">
                  <div className="icon">💬</div>
                  <p>实时沟通</p>
                </div>
                <div className="feature">
                  <div className="icon">📁</div>
                  <p>文件共享</p>
                </div>
                <div className="feature">
                  <div className="icon">📅</div>
                  <p>日程安排</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
